import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import { Link as RouterLink } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Collapse,
  Divider,
  Grid,
  InputAdornment,
  Modal,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../../services/api";

// Importações do DatePicker
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { StatusChipModal } from "../../../utils/chipsErp/chipStatusModal";
import VirtualizedAutocomplete from "../../../components/virtualization/virtualizedAutocomplete";
import { renderOpcaoCliente } from "../../../components/opcaoCliente";
import useStyles from "./styles";
import TicketModalContent from "../../../components/tickets/detailsTicketComponent";
import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";
import { LoadingButton } from "@mui/lab";
import { Link } from "react-router-dom";

dayjs.locale("pt-br");

const INITIAL_FILTERS = {
  dataInicial: dayjs().subtract(7, "day"),
  dataFinal: dayjs(),
  status: [],
  responsaveis: [],
  motivosFechamento: [],
  clientes: [],
};

export default function WorkSpace() {
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;

  const theme = useTheme();
  const styles = useStyles(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down("xl"));

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTicketDetails, setLoadingTicketDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  // Função auxiliar para carregar e converter as datas corretamente
  const loadFiltersFromStorage = () => {
    const storedFilters = localStorage.getItem("filterWorkspace");
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      return {
        ...parsedFilters,
        // Converte as strings de volta para objetos dayjs
        dataInicial: parsedFilters.dataInicial
          ? dayjs(parsedFilters.dataInicial)
          : null,
        dataFinal: parsedFilters.dataFinal
          ? dayjs(parsedFilters.dataFinal)
          : null,
      };
    }
    return INITIAL_FILTERS;
  };

  const [filters, setFilters] = useState(loadFiltersFromStorage());
  const [appliedFilters, setAppliedFilters] = useState(
    loadFiltersFromStorage(),
  );

  // Paginação individualizada
  const [pageOpen, setPageOpen] = useState(0);
  const [rowsPerPageOpen, setRowsPerPageOpen] = useState(10);

  const [pageResolved, setPageResolved] = useState(0);
  const [rowsPerPageResolved, setRowsPerPageResolved] = useState(10);

  const [orderBy, setOrderBy] = useState("data_cadastro");
  const [order, setOrder] = useState("desc");
  const [editedTicket, setEditedTicket] = useState(false); //Necessário para verificar se houve edição no ticket

  const [userResponsaveis, setUserResponsaveis] = useState([]);
  const [tipoAtendimento, setTipoAtendimento] = useState([]);
  const [motivosFechamentoOptions, setMotivosFechamentoOptions] = useState([]);
  const [clientesOptions, setClientesOptions] = useState([]);
  const [statusAtendimento, setStatusAtendimento] = useState([]);
  const [etapasFluxoAtendimento, setEtapasFluxoAtendimento] = useState([]);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );

  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [ticketDetails, setTicketDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [openTicketsAbertos, setOpenTicketsAbertos] = useState(true);
  const [openTicketsResolvidos, setOpenTicketsResolvidos] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [allEtapasFluxoAtendimentos, setAllEtapasFluxoAtendimentos] = useState(
    [],
  );

  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }

  const fluxoAtendimentoColor = adicionarCores(allEtapasFluxoAtendimentos);
  useEffect(() => {
    getParamsFilter();
    findTicketsWorkspace(appliedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function htmlForText(html) {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    function extrairTexto(node) {
      let texto = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          texto += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName;

          switch (tag) {
            case "BR":
              texto += "\n";
              break;
            case "P":
            case "DIV":
              texto += extrairTexto(child) + "\n";
              break;
            case "LI":
              texto += "- " + extrairTexto(child) + "\n";
              break;
            case "UL":
            case "OL":
              texto += extrairTexto(child) + "\n";
              break;
            default:
              texto += extrairTexto(child);
          }
        }
      });

      return texto;
    }

    // Extrai texto e normaliza múltiplas quebras de linha
    const resultado = extrairTexto(tempDiv);
    return resultado.replace(/\n{3,}/g, "\n\n").trim();
  }
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  const getParamsFilter = async () => {
    try {
      const response = await api.get("/interno/find/paramsFilterWorkspace");
      setUserResponsaveis(response?.data?.userResponsaveis || []);
      setTipoAtendimento(response?.data?.tipoAtendimento || []);

      const statusAtendimentoFiltered =
        response?.data?.statusAtendimento?.filter((item) => item?.id !== 3) ||
        [];
      setStatusAtendimento(statusAtendimentoFiltered);
      setEtapasFluxoAtendimento(response?.data?.etapasFluxoAtendimento || []);
      setClientesOptions(response?.data?.clientes || []);

      setMotivosFechamentoOptions(response?.data?.motivoFechamento || []);
    } catch (error) {
      console.error("Erro ao buscar parâmetros de filtros:", error);
    }
  };

  const findTicketsWorkspace = async (currentFilters) => {
    setLoading(true);
    try {
      const payload = {
        dataInicial: currentFilters.dataInicial
          ? currentFilters.dataInicial
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          : null,
        dataFinal: currentFilters.dataFinal
          ? currentFilters.dataFinal.endOf("day").format("YYYY-MM-DD HH:mm:ss")
          : null,
      };

      const response = await api.post(
        "/interno/find/tickets/workspace",
        payload,
      );
      setTickets(response?.data?.atendimentos || []);
      setAllEtapasFluxoAtendimentos(
        response?.data?.allEtapasFluxoAtendimentos || [],
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsEditOs(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
  };

  const resetPaginations = () => {
    setPageOpen(0);
    setPageResolved(0);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setConfirmacaoSaidaPagina(false);
    setValue(0);
    if (editedTicket) {
      findTicketsWorkspace(appliedFilters);
      setEditedTicket(false);
    }
  };

  const handleApplyFilters = () => {
    if (filters.dataInicial && filters.dataFinal) {
      if (filters.dataInicial.isAfter(filters.dataFinal)) {
        setSnackbar({
          children: "A data inicial não pode ser maior que a data final.",
          severity: "warning",
        });
        return;
      }
      // Nova validação de limite de 6 meses
      if (filters.dataFinal.isAfter(filters.dataInicial.add(6, "month"))) {
        setSnackbar({
          children: "O período selecionado não pode ultrapassar 6 meses.",
          severity: "warning",
        });
        return;
      }
    }

    localStorage.setItem("filterWorkspace", JSON.stringify(filters));
    setAppliedFilters(filters);
    resetPaginations();
    findTicketsWorkspace(filters);
  };

  const handleClearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setAppliedFilters(INITIAL_FILTERS);
    resetPaginations();
    findTicketsWorkspace(INITIAL_FILTERS);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const getTicketDetails = async (ticketId) => {
    try {
      setLoadingTicketDetails(true);
      const response = await api.post("/interno/find/tickets/id", {
        ticketId: ticketId,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      // setSnackbar({
      //   children: "Error: Não foi possível localizar detalhes do ticket",
      //   severity: "error",
      // });
    } finally {
      setLoadingTicketDetails(false);
    }
  };

  const handleOpen = async (ticketId) => {
    setOpen(true);

    const response = await getTicketDetails(ticketId);

    setTicketDetails(response || {});
  };

  const filteredTickets = tickets.filter((ticket) => {
    const matchesSearch =
      ticket.protocolo?.toString()?.includes(searchTerm) ||
      ticket.cliente?.nome
        ?.toLowerCase()
        ?.includes(searchTerm.toLowerCase()) ||
      ticket.descricao_abertura
        ?.toLowerCase()
        ?.includes(searchTerm.toLowerCase()) ||
      ticket.servico?.id_cliente_servico?.toString()?.includes(searchTerm) ||
      ticket.cliente?.codigo_cliente?.toString()?.includes(searchTerm);

    const ticketDate = new Date(ticket.data_cadastro).getTime();

    const startMatch = appliedFilters.dataInicial
      ? ticketDate >=
        appliedFilters.dataInicial.startOf("day").toDate().getTime()
      : true;

    const endMatch = appliedFilters.dataFinal
      ? ticketDate <= appliedFilters.dataFinal.endOf("day").toDate().getTime()
      : true;

    const motivoFechamentoMatch =
      appliedFilters.motivosFechamento?.length > 0
        ? appliedFilters.motivosFechamento?.includes(
            ticket.motivoFechamento?.id,
          )
        : true;

    const statusMatch =
      appliedFilters.status?.length > 0
        ? appliedFilters.status.some(
            (s) =>
              ticket.status?.descricao?.toLowerCase() === s.toLowerCase() ||
              ticket.status_fechamento?.toLowerCase() === s.toLowerCase(),
          )
        : true;
    const clienteMatch =
      appliedFilters.clientes?.length > 0
        ? appliedFilters.clientes?.some(
            (selectedErpId) =>
              String(ticket.cliente?.codigo_cliente) === String(selectedErpId),
          )
        : true;

    const respMatch =
      appliedFilters.responsaveis?.length > 0
        ? ticket.usuario_responsavel?.some((ur) =>
            appliedFilters.responsaveis?.includes(ur.id),
          )
        : true;

    const tipoMatch =
      appliedFilters.tiposAtendimento?.length > 0
        ? appliedFilters.tiposAtendimento?.includes(ticket.tipoAtendimento?.id)
        : true;

    const etapaMatch =
      appliedFilters.etapasFluxo?.length > 0
        ? appliedFilters.etapasFluxo?.includes(
            ticket.id_fluxo_atendimento_etapa,
          )
        : true;

    return (
      matchesSearch &&
      startMatch &&
      endMatch &&
      statusMatch &&
      respMatch &&
      tipoMatch &&
      etapaMatch &&
      motivoFechamentoMatch &&
      clienteMatch
    );
  });

  const sortedTickets = [...filteredTickets].sort((a, b) => {
    let valueA = a[orderBy];
    let valueB = b[orderBy];

    if (orderBy === "cliente") {
      valueA = a.cliente?.nome || "";
      valueB = b.cliente?.nome || "";
    } else if (orderBy === "status") {
      valueA = a.status?.descricao || "";
      valueB = b.status?.descricao || "";
    } else if (orderBy === "tipo_atendimento") {
      valueA = a.tipoAtendimento?.descricao || "";
      valueB = b.tipoAtendimento?.descricao || "";
    }

    if (valueA === null || valueA === undefined) valueA = "";
    if (valueB === null || valueB === undefined) valueB = "";

    const compareRes = valueA
      .toString()
      .localeCompare(valueB.toString(), undefined, {
        numeric: true,
        sensitivity: "base",
      });

    return order === "asc" ? compareRes : -compareRes;
  });

  // ===== DIVISÃO ENTRE ABERTOS E RESOLVIDOS =====
  const resolvedTicketsFull = sortedTickets.filter((ticket) => {
    const statusDesc = ticket.status?.descricao?.toLowerCase() || "";
    // Ajuste aqui se a string de finalização no seu banco for diferente (ex: "fechado")
    return statusDesc === "resolvido" || statusDesc === "concluído";
  });

  const openTicketsFull = sortedTickets.filter((ticket) => {
    const statusDesc = ticket.status?.descricao?.toLowerCase() || "";
    return statusDesc !== "resolvido" && statusDesc !== "concluído";
  });

  const paginatedOpenTickets = openTicketsFull.slice(
    pageOpen * rowsPerPageOpen,
    pageOpen * rowsPerPageOpen + rowsPerPageOpen,
  );

  const paginatedResolvedTickets = resolvedTicketsFull.slice(
    pageResolved * rowsPerPageResolved,
    pageResolved * rowsPerPageResolved + rowsPerPageResolved,
  );

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return (
      date.toLocaleDateString("pt-BR") +
      " " +
      date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
    );
  };

  const renderResponsaveisTooltip = (responsaveis) => {
    if (!responsaveis || responsaveis?.length === 0)
      return "Nenhum responsável";
    return (
      <Box sx={styles.tooltipContainer}>
        <Typography
          variant="caption"
          fontWeight="bold"
          display="block"
          sx={styles.tooltipTitle}
        >
          Responsáveis:
        </Typography>
        {responsaveis.map((user, idx) => (
          <Typography
            key={user.id || idx}
            variant="caption"
            display="block"
            sx={styles.tooltipItem}
          >
            • {user?.name}
          </Typography>
        ))}
      </Box>
    );
  };

  // Função isolada para renderizar os cards/tabela e não poluir o código duas vezes
  const renderTicketView = (
    currentPaginatedTickets,
    totalCount,
    currentPage,
    setCurrentPage,
    currentRowsPerPage,
    setCurrentRowsPerPage,
  ) => {
    return (
      <Box sx={{ width: "100%" }}>
        {isMobile ? (
          <Box sx={styles.mobileCardsContainer}>
            {currentPaginatedTickets.map((ticket) => (
              <Card
                key={ticket.id_atendimento}
                elevation={0}
                variant="outlined"
                sx={styles.mobileCard}
              >
                <CardContent sx={styles.mobileCardContent}>
                  <Box sx={styles.mobileCardHeader}>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="primary.main"
                      >
                        {ticket.protocolo}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block"
                      >
                        {formatDate(ticket.data_cadastro)}
                      </Typography>
                    </Box>
                    {StatusChipModal(ticket.status?.prefixo)}
                  </Box>

                  <Typography
                    variant="body2"
                    fontWeight="600"
                    color="text.primary"
                    sx={styles.mobileClientName}
                  >
                    {ticket.cliente
                      ? `${ticket.cliente.codigo_cliente} - ${ticket.cliente.nome || ""}`
                      : "Cliente não informado"}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                    sx={styles.mobileServiceName}
                  >
                    {ticket.servico
                      ? `[${ticket.servico.id_cliente_servico}] ${ticket.servico.nome}`
                      : "Serviço não informado"}
                  </Typography>

                  <Divider sx={styles.divider} />

                  <Typography
                    variant="caption"
                    fontWeight="bold"
                    color="text.primary"
                    display="block"
                  >
                    {ticket.tipoAtendimento?.descricao}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={styles.mobileDescription}
                  >
                    {ticket.descricao_abertura}
                  </Typography>

                  <Box sx={styles.mobileCardFooter}>
                    <Box>
                      {ticket.data_fechamento && (
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          Fechamento: <br />{" "}
                          {formatDate(ticket.data_fechamento)}
                        </Typography>
                      )}
                    </Box>

                    <Tooltip
                      title={renderResponsaveisTooltip(
                        ticket.usuario_responsavel,
                      )}
                      arrow
                      placement="top"
                    >
                      <Box>
                        <AvatarGroup max={3} sx={styles.mobileAvatarGroup}>
                          {ticket.usuario_responsavel?.map((user) => (
                            <Avatar
                              key={user.id}
                              alt={user.name}
                              src={user.imagem?.link}
                            />
                          ))}
                        </AvatarGroup>
                      </Box>
                    </Tooltip>
                  </Box>
                </CardContent>
              </Card>
            ))}
            {currentPaginatedTickets?.length === 0 && (
              <Typography
                variant="body2"
                color="text.secondary"
                align="center"
                sx={styles.noTicketsTextMobile}
              >
                Nenhum ticket encontrado.
              </Typography>
            )}
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={styles.tableContainer}
          >
            <Table sx={styles.table}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "protocolo"}
                      direction={orderBy === "protocolo" ? order : "asc"}
                      onClick={() => handleRequestSort("protocolo")}
                    >
                      Protocolo
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "data_cadastro"}
                      direction={orderBy === "data_cadastro" ? order : "asc"}
                      onClick={() => handleRequestSort("data_cadastro")}
                    >
                      Data abertura
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "cliente"}
                      direction={orderBy === "cliente" ? order : "asc"}
                      onClick={() => handleRequestSort("cliente")}
                    >
                      Cliente / Serviço
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "tipo_atendimento"}
                      direction={orderBy === "tipo_atendimento" ? order : "asc"}
                      onClick={() => handleRequestSort("tipo_atendimento")}
                    >
                      Tipo / Descrição
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      active={orderBy === "status"}
                      direction={orderBy === "status" ? order : "asc"}
                      onClick={() => handleRequestSort("status")}
                    >
                      Status
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">Responsáveis</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentPaginatedTickets.map((ticket) => (
                  <TableRow key={ticket.id_atendimento} hover>
                    <TableCell sx={styles.tableCellProtocolo}>
                      <Typography
                        variant="body2"
                        fontWeight="700"
                        color="primary.main"
                      >
                        {ticket.protocolo}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        color="text.primary"
                        display="block"
                      >
                        {formatDate(ticket.data_cadastro)}
                      </Typography>
                      {ticket.data_fechamento && (
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          F: {formatDate(ticket.data_fechamento)}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title={`${ticket.cliente?.codigo_cliente || "N/A"} - ${ticket.cliente?.nome || ""}`}
                        arrow
                      >
                        {ticket.cliente ? (
                          <Tooltip
                            title={`${ticket.cliente?.codigo_cliente || "N/A"} - ${ticket.cliente?.nome || ""}`}
                            arrow
                          >
                            {ticket.cliente ? (
                              <Typography
                                component={RouterLink}
                                to={`/interno/home/perfil/servicos/${ticket.cliente.clienteId}`}
                                variant="body2"
                                noWrap
                                sx={{
                                  ...styles.tableCellClientText,
                                  display: "block",
                                  color: "text.primary",
                                  textDecoration: "none",
                                  "&:hover": {
                                    textDecoration: "underline",
                                    color: "text.primary",
                                  },
                                }}
                              >
                                {`${ticket.cliente.codigo_cliente} - ${ticket.cliente.nome || ""}`}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body2"
                                noWrap
                                sx={styles.tableCellClientText}
                              >
                                N/A
                              </Typography>
                            )}
                          </Tooltip>
                        ) : (
                          <Typography
                            variant="body2"
                            noWrap
                            sx={styles.tableCellClientText}
                          >
                            N/A
                          </Typography>
                        )}
                      </Tooltip>
                      <Tooltip
                        title={`ID Serv: ${ticket.servico?.id_cliente_servico || "N/A"} | ${ticket.servico?.nome || ""}`}
                        arrow
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          noWrap
                          sx={styles.tableCellServiceText}
                        >
                          {ticket.servico
                            ? `${ticket.servico.id_cliente_servico} ${ticket.servico.nome}`
                            : "N/A"}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={styles.tableCellTipoText}>
                        {ticket.tipoAtendimento?.descricao}
                      </Typography>
                      <Tooltip
                        title={ticket.descricao_abertura}
                        arrow
                        placement="top"
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          noWrap
                          sx={styles.tableCellDescricaoText}
                        >
                          {ticket.descricao_abertura}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      {StatusChipModal(ticket.status?.prefixo)}
                    </TableCell>
                    <TableCell align="center">
                      <Box sx={styles.tableCellCenterBox}>
                        <Tooltip
                          title={renderResponsaveisTooltip(
                            ticket.usuario_responsavel,
                          )}
                          arrow
                          placement="top"
                        >
                          <Box sx={styles.tableCellAvatarBox}>
                            <AvatarGroup
                              max={3}
                              sx={styles.tableCellAvatarGroup}
                            >
                              {ticket.usuario_responsavel?.map((user) => (
                                <Avatar
                                  key={user.id}
                                  alt={user.name}
                                  src={user.imagem?.link}
                                />
                              ))}
                            </AvatarGroup>
                          </Box>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        sx={styles.verTicketButton}
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpen(ticket.id)}
                      >
                        Ver Ticket
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {currentPaginatedTickets?.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      sx={styles.noTicketsTableCell}
                    >
                      <Typography variant="body2" color="text.secondary">
                        Nenhum ticket encontrado.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Box sx={styles.paginationContainer}>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalCount}
            rowsPerPage={currentRowsPerPage}
            page={currentPage}
            onPageChange={(e, newPage) => setCurrentPage(newPage)}
            onRowsPerPageChange={(e) => {
              setCurrentRowsPerPage(parseInt(e.target.value, 10));
              setCurrentPage(0);
            }}
            labelRowsPerPage="Linhas por página:"
          />
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={styles.container}>
      <Paper
        elevation={3}
        variant={theme.palette.mode === "dark" ? "outlined" : "elevation"}
        sx={styles.paperContainer}
      >
        <Typography
          variant="h6"
          fontWeight="700"
          color="text.primary"
          sx={styles.title}
        >
          Meu trabalho
        </Typography>

        {/* BARRA SUPERIOR DE PESQUISA */}
        <Box sx={styles.searchBarContainer}>
          <TextField
            fullWidth
            size="small"
            placeholder="Buscar por protocolo, cliente ou descrição..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              resetPaginations();
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={styles.searchTextField}
          />
          <Button
            variant={showFilters ? "contained" : "outlined"}
            startIcon={<FilterListIcon />}
            onClick={() => setShowFilters(!showFilters)}
            sx={styles.filterButton}
            disableElevation
          >
            Filtros
          </Button>
        </Box>

        {/* SESSÃO EXPANSÍVEL DE FILTROS AVANÇADOS */}
        <Collapse in={showFilters}>
          <Box sx={styles.filtersWrapper}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <DatePicker
                    label="Data inicial"
                    value={filters.dataInicial}
                    onChange={(newValue) =>
                      setFilters({ ...filters, dataInicial: newValue })
                    }
                    slotProps={{
                      textField: { size: "small", fullWidth: true },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <DatePicker
                    label="Data final"
                    value={filters.dataFinal}
                    onChange={(newValue) =>
                      setFilters({ ...filters, dataFinal: newValue })
                    }
                    slotProps={{
                      textField: { size: "small", fullWidth: true },
                    }}
                  />
                </Grid>

                {/* AUTOCOMPLETE: CLIENTES */}
                <Grid item xs={12} sm={6} md={3}>
                  <VirtualizedAutocomplete
                    multiple
                    limitTags={1}
                    options={clientesOptions || []}
                    sx={styles.autocompleteFilter}
                    getOptionLabel={(option) =>
                      `${option.clienteErpId} - ${option.nome || "Sem Nome"}`
                    }
                    renderOption={renderOpcaoCliente()}
                    value={
                      clientesOptions?.filter((opt) =>
                        filters.clientes?.includes(opt.clienteErpId),
                      ) || []
                    }
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        // Salvando apenas o clienteErpId no array de filtros
                        clientes: newValue.map((item) => item.clienteErpId),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Clientes"
                        size="small"
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={`${option?.clienteErpId} - ${
                            option.nome || option.clienteErpId
                          }`}
                          size="small"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                {/* AUTOCOMPLETE: STATUS */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={1}
                    disableCloseOnSelect
                    options={statusAtendimento}
                    getOptionLabel={(option) => option.descricao || ""}
                    value={statusAtendimento.filter((opt) =>
                      filters.status?.includes(opt.descricao),
                    )}
                    sx={styles.autocompleteFilter}
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        status: newValue.map((v) => v.descricao),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Status"
                        placeholder="Selecionar"
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          size="small"
                          label={option.descricao}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                {/* AUTOCOMPLETE: RESPONSÁVEIS */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={1}
                    disableCloseOnSelect
                    options={userResponsaveis}
                    sx={styles.autocompleteFilter}
                    getOptionLabel={(option) => option.name || ""}
                    value={userResponsaveis.filter((opt) =>
                      filters.responsaveis?.includes(opt.id),
                    )}
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        responsaveis: newValue.map((v) => v.id),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Responsáveis"
                        placeholder="Selecionar"
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          size="small"
                          label={option.name?.trim()?.split(" ")[0]}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                {/* NOVO AUTOCOMPLETE: TIPO DE ATENDIMENTO */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={1}
                    disableCloseOnSelect
                    options={tipoAtendimento}
                    sx={styles.autocompleteFilter}
                    getOptionLabel={(option) => option.descricao || ""}
                    value={tipoAtendimento.filter((opt) =>
                      filters.tiposAtendimento?.includes(opt.id),
                    )}
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        tiposAtendimento: newValue.map((v) => v.id),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de atendimento"
                        placeholder="Selecionar"
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          size="small"
                          label={option.descricao}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                {/* AUTOCOMPLETE: MOTIVOS FECHAMENTO */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    sx={styles.autocompleteFilter}
                    options={motivosFechamentoOptions || []}
                    getOptionLabel={(option) => option.descricao || ""}
                    value={
                      motivosFechamentoOptions?.filter((opt) =>
                        filters.motivosFechamento?.includes(opt.id),
                      ) || []
                    }
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        motivosFechamento: newValue.map((item) => item.id),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Motivo de fechamento"
                        size="small"
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={option.descricao}
                          size="small"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                {/* NOVO AUTOCOMPLETE: ETAPA DO FLUXO */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={1}
                    disableCloseOnSelect
                    options={etapasFluxoAtendimento}
                    sx={styles.autocompleteFilter}
                    getOptionLabel={(option) =>
                      option.etapaFluxoAtendimento || ""
                    }
                    value={etapasFluxoAtendimento.filter((opt) =>
                      filters.etapasFluxo?.includes(
                        opt.idEtapaFluxoAtendimento,
                      ),
                    )}
                    onChange={(event, newValue) => {
                      setFilters({
                        ...filters,
                        etapasFluxo: newValue.map(
                          (v) => v.idEtapaFluxoAtendimento,
                        ),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Etapa do Fluxo"
                        placeholder="Selecionar"
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          size="small"
                          label={option.etapaFluxoAtendimento}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Box sx={styles.filterActionsContainer}>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={loading}
                      onClick={handleClearFilters}
                    >
                      Limpar Filtros
                    </Button>

                    <LoadingButton
                      variant="contained"
                      size="small"
                      loading={loading}
                      disabled={filters.dataInicial.isAfter(filters.dataFinal)}
                      onClick={handleApplyFilters}
                    >
                      Aplicar
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </LocalizationProvider>
          </Box>
        </Collapse>

        {loading ? (
          <Box sx={styles.loadingContainer}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ mt: 3 }}>
            {/* ACCORDION: ATENDIMENTOS ABERTOS */}
            <Accordion
              defaultExpanded
              variant="outlined"
              expanded={openTicketsAbertos}
              onChange={() => setOpenTicketsAbertos(!openTicketsAbertos)}
              sx={{
                backgroundColor: theme.palette.background.wallpaper,
                mb: 2,
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="subtitle1"
                  fontWeight="600"
                  color="primary"
                >
                  Tickets abertos ({openTicketsFull.length})
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {renderTicketView(
                  paginatedOpenTickets,
                  openTicketsFull.length,
                  pageOpen,
                  setPageOpen,
                  rowsPerPageOpen,
                  setRowsPerPageOpen,
                )}
              </AccordionDetails>
            </Accordion>

            {/* ACCORDION: ATENDIMENTOS RESOLVIDOS */}
            <Accordion
              sx={{ backgroundColor: theme.palette.background.wallpaper }}
              variant="outlined"
              expanded={openTicketsResolvidos}
              onChange={() => setOpenTicketsResolvidos(!openTicketsResolvidos)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="subtitle1"
                  fontWeight="600"
                  color="text.secondary"
                >
                  Tickets resolvidos ({resolvedTicketsFull.length})
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 2 }}>
                {renderTicketView(
                  paginatedResolvedTickets,
                  resolvedTicketsFull.length,
                  pageResolved,
                  setPageResolved,
                  rowsPerPageResolved,
                  setRowsPerPageResolved,
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
        )}
      </Paper>

      <TicketModalContent
        open={open}
        loading={loadingTicketDetails}
        handleClose={handleClose}
        /*  onClose={handleClose} */
        erp={erp}
        ticketDetails={ticketDetails}
        //status={statusChamado[status]}
        labelTabsErp={labelTabsErp}
        value={value}
        handleChange={handleChange}
        isEdit={true}
        setTicketDetails={setTicketDetails}
        itensPublic={itensPublic}
        setItensPublic={setItensPublic}
        htmlForText={htmlForText}
        setSnackbar={setSnackbar}
        fluxoAtendimentoColor={fluxoAtendimentoColor}
        setEditedTicket={setEditedTicket}
        //historicoFluxoAtendimento={historicoFluxoAtendimento}
        setIsEditTicket={setIsEditTicket}
        isEditTicket={isEditTicket}
        setIsFinishTicket={setIsFinishTicket}
        isFinishTicket={isFinishTicket}
        isEditOs={isEditOs}
        setIsEditOs={setIsEditOs}
        setIsNewOs={setIsNewOs}
        isNewOs={isNewOs}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={handleClose}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
